










import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class RoundFilterButton extends Vue {
  @Prop({ default: false })
  isDisabled!: boolean

  @Prop({ default: true })
  isVisible!: boolean
}
